import { postionsConstants } from '../../constants/position';
import { reportConstants } from '../../constants/reports';

export type GameFormKey =
	| 'game_name'
	| 'custom_game_id'
	| 'notes'
	| 'game_provider_id'
	| 'provider_game_id_desktop'
	| 'provider_game_id_mobile'
	| 'aams_type_id'
	| 'rtp'
	| 'volatility'
	| 'wagering_weight'
	| 'is_slot';

const gamesListMap = [
	{
		label: reportConstants.REPORT_GAME_ID,
		key: reportConstants.COLUMN_GAME_ID,
	},
	{
		label: reportConstants.REPORT_ACTIVE,
		key: reportConstants.COLUMN_ACTIVE,
	},
	{
		label: reportConstants.REPORT_GAME_NAME,
		key: reportConstants.COLUMN_GAME_NAME,
	},
	{
		label: reportConstants.REPORT_GAME_PROVIDER,
		key: reportConstants.COLUMN_GAME_PROVIDER,
	},
	{ label: reportConstants.REPORT_SLOT, key: reportConstants.COLUMN_IS_SLOT, position: postionsConstants.CENTAR },
	{
		label: reportConstants.REPORT_GAME_PROVIDER_ID,
		key: reportConstants.COLUMN_PROVIDER_GAME_ID_DESKTOP,
	},
	{
		label: reportConstants.REPORT_AAMS_GAME_ID,
		key: reportConstants.COLUMN_AAMS_GAME_ID,
	},
	{
		label: reportConstants.REPORT_AAMS_GAME_TYPE,
		key: reportConstants.COLUMN_AAMS_GAME_TYPE,
	},
	{
		label: reportConstants.REPORT_PGDA_831,
		key: reportConstants.COLUMN_CHECKSUM_RESULT,
		position: postionsConstants.CENTAR,
	},
	{
		label: reportConstants.REPORT_NOTES,
		key: reportConstants.COLUMN_NOTES,
		position: postionsConstants.CENTAR,
	},
	{
		label: 'Actions',
		key: 'actions',
		position: postionsConstants.CENTAR,
	},
];

const columnFormatter = {
	game_id: 'value',
	custom_game_id: 'value',
	active: 'value',
	game_name: 'value',
	provider_name: 'value',
	is_slot: 'value',
	provider_game_id_desktop: 'value',
	checksum_result: 'value',
	notes: 'value',
};

const formNameMap = {
	name: 'Game name',
	notes: 'Notes',
	game_provider_id: 'Game provider',
	provider_game_id_desktop: 'ID',
	provider_game_id_mobile: 'ID',
	aams_type_id: 'AAMS Type',
	rtp: 'RTP',
	volatility: 'Volatility',
	wagering_weight: 'Wagering weight',
};

export { gamesListMap, columnFormatter, formNameMap };
